import { useCallback } from 'react';
import { ApiLoginWarning } from 'Constants/index';
import { redirect } from 'Utilities/browser';
import { persistAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { getLegacyToken, signIn } from 'Services/auth';
import useAuth from '../../useAuth';
const useCommercialApiAuth = () => {
  const {
    handleLoginError,
    handleLockoutError,
    handleForgotPasswordDone,
    handleResetPasswordDone,
    handleCountryRegionError,
    handleUnexpectedError,
    showHcpError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmatioMessage,
    showTokenExpirationError,
    showCountryRegionError,
    isLocked,
    lockoutMessage,
    lockoutSubmessage,
    navigateToPhoneVerification
  } = useAuth();
  const redirectUserAfterAuth = useCallback(async ({
    accessToken,
    accountId,
    app,
    regions,
    sharingWebviewsUrl,
    country,
    pId
  }) => {
    const legacyToken = await getLegacyToken(app, accountId, accessToken);
    const regionEntry = Object.entries(regions).find(([, {
      countries
    }]) => countries.includes(country));
    const region = regionEntry ? regionEntry[0] : 'eu';
    const legacyConnectedAppsUrl = `${sharingWebviewsUrl}?token=${legacyToken}&pId=${pId}&region=${region}`;
    redirect(legacyConnectedAppsUrl);
  }, []);
  const authenticateUser = useCallback(async (email, password, redirectUser = true) => {
    const {
      app,
      pId,
      cid
    } = store.getState().env;
    const {
      sharingWebviewsUrl,
      regions
    } = store.getState().config;
    if (!sharingWebviewsUrl || !regions) {
      return;
    }
    const {
      accessToken,
      accountId,
      country,
      expires,
      verificationTasks
    } = await signIn(email, password, app);
    const unverifiedPhoneTask = verificationTasks?.find(task => task.verified === false && task.action === ApiLoginWarning.REGISTER_ACTION && task.verificationMethod === ApiLoginWarning.PHONE_VERIFICATION);
    persistAuthSession({
      accessToken,
      accountId,
      expires,
      cid,
      app,
      country
    });
    if (unverifiedPhoneTask) {
      return navigateToPhoneVerification(unverifiedPhoneTask, async () => {
        const {
          accessToken,
          accountId,
          country
        } = await signIn(email, password, app);
        if (redirectUser) {
          redirectUserAfterAuth({
            app,
            accessToken,
            accountId,
            country,
            pId,
            regions,
            sharingWebviewsUrl
          });
        }
        persistAuthSession({
          accessToken,
          accountId,
          expires,
          cid,
          app,
          country
        });
      });
    }
    if (redirectUser) {
      redirectUserAfterAuth({
        app,
        accessToken,
        accountId,
        country,
        pId,
        regions,
        sharingWebviewsUrl
      });
    }
  }, [navigateToPhoneVerification, redirectUserAfterAuth]);
  return {
    authenticateUser,
    handleLoginError,
    handleLockoutError,
    handleCountryRegionError,
    handleForgotPasswordDone,
    handleResetPasswordDone,
    handleUnexpectedError,
    showHcpError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmatioMessage,
    showTokenExpirationError,
    showCountryRegionError,
    isLocked,
    lockoutMessage,
    lockoutSubmessage
  };
};
export default useCommercialApiAuth;